export const CONTENT = 'content'
export const ANALYSIS = 'analysis'
